import createBaseService from "@/api/base-service.ts";
import type { Role } from "../../types/role";

const roleListService = {
	...createBaseService<Role>("/roles-list"),
};

export default roleListService;
